import {
    apiRequest,
    skillcertificationDetail
} from "../../../../../services/adapters/kepegawaian/skillcertificationService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", skillcertificationDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository